// initial state
const state = () => ({
    searchQuery:{
        no: undefined,
        status: 0,
        currentPage: 1
    }
})

// getters
const getters = {}

// actions
const actions = {
    // getAllProducts ({ commit }) {
    //     shop.getProducts(products => {
    //         commit('setProducts', products)
    //     })
    // }
}

// mutations
const mutations = {
    storeSearchQuery(state, searchQuery) {
        state.searchQuery = JSON.parse(JSON.stringify(searchQuery))
    },
    cleanSearchQuery(state) {
        state.searchQuery = {
            no: undefined,
            status: undefined,
            currentPage: 1
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
